import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from "antd"

class Statics extends Component {
    render() {
        const {result} = this.props
        const checkObject = (result !== undefined && result !== null && Object.keys(result).length > 0)
        const skip = (checkObject && result.count_page_total !== undefined) && (parseInt(result.count_page_total) - parseInt(result.count_page_valid))

        return (
            checkObject ?
                <td className="statics">
                    <Tooltip title="Số lượng label thành công">
                        <strong className='text-success'>{result.count_page_success}</strong>
                    </Tooltip> /
                    <Tooltip title="Số lượng label skip">
                        <strong className='text-success'>{skip || '-'}</strong>
                    </Tooltip> /
                    <Tooltip title="Số lượng label lỗi">
                        <strong className='text-danger'>{result.count_page_failed}</strong>
                    </Tooltip> /
                    <Tooltip title="Tổng label trong file">
                        <strong>{result.count_page_total}</strong>
                    </Tooltip>
                </td> :
                <td className="statics">
                    <Tooltip title="Không có dữ liệu">
                        <strong className='text-danger'>-</strong>
                    </Tooltip>
                </td>
        )
    }
}

Statics.propTypes = {
    result: PropTypes.object
}

export default Statics